import { BLOB_ID } from '../../../constants/blobId';
import {
  agentIdSelector,
  openedChatsSelector,
  userSelector,
  parentSourceSelector,
  contextTokenSelector,
  isEarlyAccessSelector,
} from '../../../selectors';
import { hintQuestionsSelector } from '../../../selectors/hintQuestionsSelector';
import { EEventQueueEvents } from '../../../types/eventQueue';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { isInIframe } from '../../../utils/isInIframe';
import { setFirstMessageSent } from '../actions';
import { trackFirstMessageSent } from '../tracking';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertSuccessStatus =
  (
    response: TFirstMessageResponse,
    { isAnalyticsKeyDisabled, text, startTime, telemetry }: IAssertDependencies,
  ): TThunkAction<void> =>
  (dispatch, getState) => {
    if (response.status === EFirstMessageResponseStatus.Success) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendSuccess);
      telemetry.timing(ETelemetryEvents.ChatFirstMessageSendTime, Date.now() - startTime);

      const state = getState();
      const agentId = agentIdSelector(state);
      const openedChats = openedChatsSelector(state);
      const user = userSelector(state);
      const hintQuestions = hintQuestionsSelector(state);
      const parentSource = parentSourceSelector(state);
      const contextToken = contextTokenSelector(state);
      const isEarlyAccess = isEarlyAccessSelector(state);

      const { ga, newChatId } = openedChats[BLOB_ID];

      const { analyticsKey = null } = hintQuestions.find(({ messageText }) => messageText === text) || {};

      const { data: chat } = response;

      // значит уже отправлена метрика по этому чату
      if (newChatId !== chat.chatId) {
        trackFirstMessageSent({
          ga,
          users: chat.users,
          offerId: chat.offer?.id,
          agentId,
          userId: user.userId,
          analyticsKey: isAnalyticsKeyDisabled ? null : analyticsKey,
          pageTypeSource: parentSource,
          isEarlyAccess,
          chatId: chat.chatId,
          ...(contextToken && { contextToken }),
        });
      }

      dispatch(setFirstMessageSent({ chat }));

      /* istanbul ignore next */
      if (isInIframe() && window.parent) {
        // Новый чат создается в попапе, в шапку отправляем chatId, чтобы не показывать по нему уведомление
        window.parent.postMessage(
          {
            type: EEventQueueEvents.OpenNewChat,
            payload: { chatId: chat.chatId },
          },
          '*',
        );
      }
    }
  };
